import type { NotificacaoResumo } from '@/api/usuariosApi'

export type NotificacaoMeta = {
  icon: string
  label: string
  tone: 'agenda' | 'cancel' | 'update' | 'info' | 'admin'
}

const TIPO_META: Record<string, NotificacaoMeta> = {
  agendamento_criado: { icon: '✓', label: 'Agendamento confirmado', tone: 'agenda' },
  novo_agendamento: { icon: '📅', label: 'Novo agendamento', tone: 'agenda' },
  agendamento_atualizado: { icon: '↻', label: 'Agendamento atualizado', tone: 'update' },
  agendamento_cancelado: { icon: '✕', label: 'Agendamento cancelado', tone: 'cancel' },
  lembrete: { icon: '⏰', label: 'Lembrete', tone: 'agenda' },
  novo_agendamento_admin: { icon: '📋', label: 'Aviso interno', tone: 'admin' },
  agendamento_cancelado_admin: { icon: '📋', label: 'Cancelamento', tone: 'admin' },
  agendamento_atualizado_admin: { icon: '📋', label: 'Atualização', tone: 'admin' },
  agendamento_atualizado_profissional: { icon: '👤', label: 'Profissional', tone: 'update' },
}

export function getNotificacaoMeta(tipo: string): NotificacaoMeta {
  const key = (tipo || '').trim().toLowerCase()
  if (TIPO_META[key]) return TIPO_META[key]
  if (key.includes('cancel')) return TIPO_META.agendamento_cancelado
  if (key.includes('criad') || key.includes('novo')) return TIPO_META.agendamento_criado
  if (key.includes('atualiz') || key.includes('update')) return TIPO_META.agendamento_atualizado
  if (key.includes('lembrete') || key.includes('reminder')) return TIPO_META.lembrete
  return { icon: '🔔', label: 'Aviso', tone: 'info' }
}

export function isNotificacaoLida(n: NotificacaoResumo): boolean {
  return Number(n.lida) === 1
}

export function formatNotificacaoData(iso: string): string {
  try {
    return new Date(iso).toLocaleString('pt-PT', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return iso
  }
}

export function formatNotificacaoRelativa(iso: string): string {
  try {
    const date = new Date(iso)
    const diffMs = Date.now() - date.getTime()
    const diffMin = Math.floor(diffMs / 60000)
    if (diffMin < 1) return 'Agora'
    if (diffMin < 60) return `Há ${diffMin} min`
    const diffH = Math.floor(diffMin / 60)
    if (diffH < 24) return `Há ${diffH} h`
    const diffD = Math.floor(diffH / 24)
    if (diffD < 7) return `Há ${diffD} dia${diffD > 1 ? 's' : ''}`
    return formatNotificacaoData(iso)
  } catch {
    return iso
  }
}
